import React, { useMemo } from "react";
import { SensorDataFile, SensorDataSessionMarkerDot, Station } from "@shared/models";
import { Table } from "@shared/components";
import {
  getSensorDataSessionDotsFilesTableProperties,
  getSensorDataSessionDotsStationsTableProperties,
} from "@containers/SensorDataSession/constants";

import "./index.scss";

interface SensorDataSessionMarkerDotsTableProps {
  files: SensorDataFile[];
  stations: Partial<Station>[];
  dots: SensorDataSessionMarkerDot[];
  onRowClick: (item: SensorDataSessionMarkerDot) => void;
  onDeleteDot: (dot: SensorDataSessionMarkerDot) => void;
}

const SensorDataSessionMarkerDotsTable = (props: SensorDataSessionMarkerDotsTableProps) => {
  const { dots, files, onDeleteDot, stations, onRowClick } = props;

  const properties = useMemo(() => {
    if (!stations.length) {
      return getSensorDataSessionDotsFilesTableProperties(dots, files, onDeleteDot);
    }

    return getSensorDataSessionDotsStationsTableProperties(dots, stations, onDeleteDot);
  }, [onDeleteDot, files, stations, dots]);

  return (
    <div className="sensor-data-session-marker-dots-table">
      <Table items={dots} properties={properties} onRowClick={onRowClick} />
    </div>
  );
};

export default SensorDataSessionMarkerDotsTable;
